import { Form } from 'formik';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import {
  DialogProps,
  FormControls,
  FormikTextField,
  FormikDialog,
} from 'components';
import { TranslationNamespace } from 'i18n';

type Props = {
  telegramUserId?: string;
} & DialogProps;

export const TelegramUserSignInDialog: React.FC<Props> = ({
  telegramUserId,
  ...rest
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.telegram_flow.telegram_users.sign_in_dialog',
  });
  const { t: tCommon } = useTranslation();

  const initialValues = useMemo(
    () => ({
      code: '',
    }),
    [],
  );

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        code: Yup.string()
          .min(1, tCommon('errors.required'))
          .required(tCommon('errors.required')),
      }),
    [tCommon],
  );

  return (
    <FormikDialog
      dialogProps={{
        title: t('title'),
        ...rest,
      }}
      formikProps={{
        initialValues,
        validationSchema,
        validateOnMount: false,
        validateOnChange: true,
        validateOnBlur: true,
        enableReinitialize: true,
      }}
    >
      {() => (
        <Form>
          <FormControls>
            <p>{t('description')}</p>
            <FormikTextField
              name="code"
              label={t('fields.code')}
              required
              autoFocus
            />
          </FormControls>
        </Form>
      )}
    </FormikDialog>
  );
};
